import styled from 'styled-components';
import { ButtonNoneStyled } from '@components/ButtonNoneStyled';
import { themeColor, themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import Carousel from 'nuka-carousel';

export const SlideButton = styled(ButtonNoneStyled)`
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  height: ${themeSpace(9)};
  width: ${themeSpace(9)};
  background-color: rgba(247, 247, 247, 0.7);
  box-shadow: 0px 7px 16px -8px rgba(0, 0, 0, 0.3), 0px 10px 27px -5px rgba(44, 41, 37, 0.25);
  position: absolute;
  &:hover svg {
    color: ${themeColor('neutra6')};
  }
  ${themeMediaQuery('below_sm')} {
    height: ${themeSpace(7)};
    width: ${themeSpace(7)};
  }
  ${themeMediaQuery('tablet')} {
    top: ${themeSpace(2)};
  }
`;

export const PreviousSlideButton = styled(SlideButton)`
  left: ${themeSpace(4)};
  ${themeMediaQuery('sm')} {
    left: ${themeSpace(4)};
  }
`;

export const NextSlideButton = styled(SlideButton)`
  right: ${themeSpace(4)};
  ${themeMediaQuery('sm')} {
    right: ${themeSpace(4)};
  }
`;

export const StyledCarousel = styled(Carousel)`
  .slider-slide:not(.slide-visible) {
    visibility: hidden;
  }
  .slider-slide {
    :focus {
      outline: none;
    }
  }
`;
